import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'
import { ArticleVersionModel } from '@editor/store/slices/articleVersion.slice'

// Define the Article type (you should have this defined elsewhere in your project)
export interface ArticleModel {
  id: string
  title: string
  content: string
  author: string
  latest_version?: ArticleVersionModel
  url: string
  datePublished: string
  articleId: string
}

// Create the generic slice for the Article entity
const {
  slice: articlesSlice,
  thunks: articleThunks,
  adapter: articlesAdapter,
} = createGenericSlice<ArticleModel>(
  'Article',
  'article',
  {} // You can define extra initial state here if needed
)

export const {
  selectAll: selectAllArticles,
  selectById: selectArticleById,
  // ... other selectors
} = articlesAdapter.getSelectors<RootState>(
  (state: RootState) => state.articles
)

export const { fetchAll: fetchAllArticles, fetchById: fetchArticleById } =
  articleThunks

export default articlesSlice.reducer
